import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, array, boolean, object, string } from "yup";
import "Forms/Schemas/customMethods";

export type OtherExpenseCustomItem = { name?: string; value?: string };

export type OtherExpenseFormType = {
  readonly aggregatedAmount?: string;
  readonly detailed?: boolean;
  readonly customItems?: OtherExpenseCustomItem[];
};

export const getOtherExpenseFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<OtherExpenseFormType> = (t) => {
  const customItemSchema = object({
    name: string().required(t(Resources.Validation.Required)),
    value: string()
      .required(t(Resources.Validation.Required))
      .greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 })),
  });

  return object({
    detailed: boolean().optional(),
    aggregatedAmount: string().when(["detailed"], ([detailed], schema) =>
      !detailed
        ? schema.required(t(Resources.Validation.Required)).greaterThanZero(t(Resources.Validation.Number.MoreThen, { count: 0 }))
        : schema.optional(),
    ),
    customItems: array().when(["detailed"], ([detailed], schema) => {
      return detailed ? schema.of(customItemSchema).optional() : schema.optional().nullable();
    }),
  }).defined();
};
